import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import groupBy from 'lodash/groupBy';
import capitalize from 'lodash/capitalize';
import { GlossaryItem } from './reducers';

export const getGlossary = (state: RootState) => state.glossary;

export const getGlossariesLoading = createSelector(getGlossary, glossary => glossary.loading);

export const getGlossaries = createSelector(getGlossary, glossary => glossary.data);

export const getItemByTerm = (glossary: GlossaryItem[], term: string): GlossaryItem => {
  return glossary.find((item: GlossaryItem) => item.Term.toLowerCase() === term.toLowerCase());
};

export const groupedGlossary = createSelector(getGlossaries, glossaries =>
  groupBy(glossaries, (value: GlossaryItem) => capitalize(value.Term).substring(0, 1))
);
